const LightThemeEllipses = () => {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden dark:hidden" aria-hidden>
      <div className="absolute -right-[115px] -top-[100px] h-[761px] w-[761px] rounded-full bg-[radial-gradient(circle,rgba(227,253,90,0.35)_0%,rgba(227,253,90,0.22)_34%,rgba(227,253,90,0.08)_52%,rgba(227,253,90,0)_70%)]" />
      <div className="absolute -left-[200px] top-[281px] h-[985px] w-[985px] rounded-full bg-[radial-gradient(circle,rgba(210,206,229,0.55)_0%,rgba(210,206,229,0.28)_42%,rgba(210,206,229,0)_68%)]" />
    </div>
  )
}

export default LightThemeEllipses
